export default __webpack_public_path__ + "static/media/portfolio-hover-170.d1439d1c.jpg";